import React, { useState, forwardRef, useRef, useEffect } from 'react'
import { getEmptyImage } from 'react-dnd-html5-backend'
import useAccessibleDrag from '../hooks/useAccessibleDrag'
import useAccessibleDrop from '../hooks/useAccessibleDrop'
import useDragAndDropContext from '../hooks/useDragAndDropContext'

const DefaultSource = forwardRef((props, ref) => {
  return <button ref={ref} data_component_id='DefaultSource' {...props}>{props.data.label}</button>
})

const DragSource = (props) => {

  const {
    source:Source = DefaultSource,
    type = 'default',
    style,
    data,
    all,  
    onMove = ()=>{},
    className
  } = props

  const {
    allowSort,
    customDragLayer,
    disabled = false
  } = useDragAndDropContext()

  const disableSource = disabled || data.aS.indexOf('disabled')!==-1

  const itemRef = useRef(null)

  const [{ isDragging, dragOffset, dragId }, drag, dragPreview] = useAccessibleDrag({
    type,
    item: {
      data,

    },
    canDrag:!disableSource,
    collect (monitor) {
      const isDragging = monitor.isDragging()
      const dragOffset = monitor.getDifferenceFromInitialOffset() || {
        x: 0,
        y: 0,
      };
      const dragId = monitor.getHandlerId()
      return {
        isDragging,
        dragOffset,
        dragId
      }

    }
  })
  const [{ dropId }, drop] = useAccessibleDrop((!allowSort && {accept:'', collect(monitor) {return {dropId: monitor.getHandlerId()}}})||{
    accept: type,
    zone: {
      dragId:dragId,
      data,
    },
    collect(monitor) {
      return {
        dropId: monitor.getHandlerId()
      };
    },
    hover(item, monitor) {
      if (!itemRef.current) {
        return;
      }
      const dragIndex = item.data.k;
      const hoverIndex = data.k;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = itemRef.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
          (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top'
      //console.log("DragItem", monitor, monitor.getItem(), monitor.getItemType(), monitor.getInitialSourceClientOffset(),  monitor.getSourceClientOffset(), monitor.getClientOffset())
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        //console.log(clientOffset, 'lower than object');
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        //console.log(clientOffset, 'higher than object');
        return;
      }
      // Time to actually perform the action
      console.log('move')
      onMove(item.data, data);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      //item.k = hoverIndex;
    }

  })

  useEffect(() => {
    customDragLayer && dragPreview(getEmptyImage(), {captureDraggingState:true})

  }, [])


  const sourceAttributes = {
    "data-draggable":"item",
    "draggable":"true",
    "aria-roledescription":"draggable",
    "aria-grabbed":isDragging ? "true" : "false",
    "aria-dropeffect": "move"
  }
  if(itemRef.current)drag(drop(itemRef))
  let newData = {...data}
  if (isDragging) newData.aS += ' dragging'
  return (
      <Source
          ref={itemRef}
          all={all}
          sourceAttributes={sourceAttributes}
          disabled={disableSource}
          className={`${className?className:''}`}
          data={newData}
          style={style}
          // Changed the DnD_Id property to lowercase because react was warning about unrecognized DOM attribute
          dnd_id={`${dragId}_${dropId}`}

      />
  )
}

export default DragSource